// based on https://colorhunt.co/palette/2763

import { themes } from 'spectacle';

export default themes.defaultTheme(
  {
    primary: '#eeeeee',
    secondary: '#393e46',
    tertiary: '#222831',
    quaternary: '#00adb5',
  },
  {
    primary: 'Helvetica',
    secondary: 'Helvetica',
  }
);
